// extracted by mini-css-extract-plugin
export default {"row":"dRAtcia74ax6GspJ5Sey","spaced":"TNypPB3ip9JdmgRlKnWv"};